(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (() => {
    const bar = document.querySelector('.js-blog-progress-bar');
    if (!bar) return;
    const root = document.documentElement;
    const updateProgress = () => {
      const scrollable = root.scrollHeight - window.innerHeight;
      if (scrollable <= 0) {
        bar.style.width = '0%';
        return;
      }
      const progress = Math.min(100, Math.max(0, (window.scrollY / scrollable) * 100));
      bar.style.width = `${progress}%`;
    };
    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-product-faq]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (!(root instanceof HTMLElement)) return;
      const singleOpen = root.dataset.singleOpen === 'true';
      const detailsList = root.querySelectorAll('[data-product-faq-details]');

      const syncAria = (det) => {
        const summary = det.querySelector('summary');
        if (summary instanceof HTMLElement) {
          summary.setAttribute('aria-expanded', det.open ? 'true' : 'false');
        }
      };

      detailsList.forEach((det) => {
        if (!(det instanceof HTMLDetailsElement)) return;
        syncAria(det);

        det.addEventListener('toggle', () => {
          syncAria(det);

          if (!singleOpen || !det.open) return;

          detailsList.forEach((other) => {
            if (other instanceof HTMLDetailsElement && other !== det && other.open) {
              other.open = false;
              syncAria(other);
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
